function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React from 'react';
import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import { useBoolean } from 'react-use';
import T from 'prop-types';
import { Button } from '../../../../components/button';
import { Chip } from '../../../../components/chip/Chip';
import { Control } from '../../../../components/form';
import { OCCUPATION } from '../../../../constants/occupation';
import text from '../../../../text';
import { onboardingConstants } from './constants';
import { useOnboarding } from './reducer';
var Profession = function(param) {
    var onSubmit = param.onSubmit;
    var _useOnboarding = _sliced_to_array(useOnboarding(), 2), _useOnboarding_ = _useOnboarding[0], profession = _useOnboarding_.profession, fullName = _useOnboarding_.fullName, phoneNumber = _useOnboarding_.phoneNumber, isMarketingEnabled = _useOnboarding_.isMarketingEnabled, dispatch = _useOnboarding[1];
    var _useBoolean = _sliced_to_array(useBoolean(false), 2), hasOther = _useBoolean[0], setHasOther = _useBoolean[1];
    var _useBoolean1 = _sliced_to_array(useBoolean(false), 2), loading = _useBoolean1[0], setLoading = _useBoolean1[1];
    var disabled = !profession || loading;
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            onSubmit({
                                profession: profession,
                                fullName: fullName,
                                phoneNumber: phoneNumber,
                                isMarketingEnabled: isMarketingEnabled
                            })
                        ];
                    case 1:
                        _state.sent();
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = function() {
        handleSubmit();
    };
    var onToggleProfession = function(payload, other) {
        setHasOther(other);
        dispatch({
            type: onboardingConstants.TOGGLE_PROFESSION,
            payload: payload
        });
    };
    var onClickOther = function() {
        return onToggleProfession('');
    };
    var handleChange = function(e) {
        return dispatch({
            type: onboardingConstants.TOGGLE_PROFESSION,
            payload: e.target.value
        });
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal.Header, null, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column align-items-center flex-fill"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-center w-100 font-24 mb-2"
    }, text('enterOccupation')), /*#__PURE__*/ React.createElement("p", {
        className: "text-center font-16"
    }, text('selectKeyRole'), ":"))), /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement("div", {
        className: cn('d-flex flex-row align-items-center justify-content-center pt-2 flex-wrap flex-gap-8', {
            'pb-4': hasOther,
            'pb-5': !hasOther
        })
    }, Object.values(OCCUPATION).map(function(occupation) {
        return /*#__PURE__*/ React.createElement(Chip, {
            key: occupation,
            label: occupation,
            onSelect: function() {
                return OCCUPATION.OTHER === occupation ? onClickOther() : onToggleProfession(occupation, false);
            },
            active: profession === occupation || hasOther && occupation === OCCUPATION.OTHER
        });
    })), hasOther ? /*#__PURE__*/ React.createElement("div", {
        className: cn('px-4', {
            'pb-4': !hasOther
        })
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-1 font-14 font-weight--600"
    }, text('otherOccupation')), /*#__PURE__*/ React.createElement(Control, {
        as: "input",
        type: "text",
        name: "profession",
        value: profession || '',
        onChange: function(e) {
            return handleChange(e);
        },
        placeholder: text('enterOccupation'),
        autoComplete: "off",
        className: "mt-0"
    })) : null, /*#__PURE__*/ React.createElement(Button, {
        disabled: disabled,
        onClick: onClick,
        className: "btn-block mt-4 w-100",
        loading: loading
    }, text('goToDashboard'))));
};
Profession.propTypes = {
    onSubmit: T.func.isRequired
};
export default Profession;
